export default [
  '126.com',
  '163.com',
  'aim.com',
  'alice.it',
  'aliceadsl.fr',
  'aol.com',
  'arcor.de',
  'att.net',
  'bellsouth.net',
  'bigpond.com',
  'bigpond.net.au',
  'bk.ru',
  'bluewin.ch',
  'blueyonder.co.uk',
  'bol.com.br',
  'centurytel.net',
  'charter.net',
  'chello.nl',
  'club-internet.fr',
  'comcast.net',
  'cox.net',
  'earthlink.net',
  'email.com',
  'foxmail.com',
  'free.fr',
  'freenet.de',
  'frontiernet.net',
  'gamil.com',
  'gmai.com',
  'gmail.co',
  'gmail.com',
  'gmail.con',
  'gmali.com',
  'gmil.com',
  'gmx.de',
  'gmx.net',
  'googlemail.com',
  'hetnet.nl',
  'home.nl',
  'hotmail.co.uk',
  'hotmail.com',
  'hotmail.de',
  'hotmail.es',
  'hotmail.fr',
  'hotmail.it',
  'icloud.com',
  'ig.com.br',
  'inbox.ru',
  'juno.com',
  'laposte.net',
  'libero.it',
  'live.ca',
  'live.co.uk',
  'live.com',
  'live.com.au',
  'live.fr',
  'live.it',
  'live.nl',
  'mac.com',
  'mail.com',
  'mail.ru',
  'mailinator.com',
  'me.com',
  'msn.com',
  'naver.com',
  'neuf.fr',
  'ntlworld.com',
  'optonline.net',
  'optusnet.com.au',
  'orange.fr',
  'outlook.com',
  'outlook.fr',
  'planet.nl',
  'protonmail.com',
  'qq.com',
  'rambler.ru',
  'rediffmail.com',
  'rocketmail.com',
  'sbcglobal.net',
  'sfr.fr',
  'shaw.ca',
  'skynet.be',
  'sympatico.ca',
  't-online.de',
  'telenet.be',
  'terra.com.br',
  'tin.it',
  'tiscali.co.uk',
  'tiscali.it',
  'trbvm.com',
  'uol.com.br',
  'verizon.net',
  'virgilio.it',
  'voila.fr',
  'wanadoo.fr',
  'web.de',
  'windstream.net',
  'yahoo.ca',
  'yahoo.co.id',
  'yahoo.co.in',
  'yahoo.co.jp',
  'yahoo.co.uk',
  'yahoo.com',
  'yahoo.com.ar',
  'yahoo.com.au',
  'yahoo.com.br',
  'yahoo.com.de',
  'yahoo.com.hk',
  'yahoo.com.jp',
  'yahoo.com.mx',
  'yahoo.com.sg',
  'yahoo.com.tw',
  'yahoo.com.uk',
  'yahoo.de',
  'yahoo.es',
  'yahoo.fr',
  'yahoo.in',
  'yahoo.it',
  'yandex.com',
  'yandex.ru',
  'ymail.com',
  'zoho.com',
  'zonnet.nl'
];
